package one.healthium.insights.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class MealDto(
    @SerialName("title") val title: String? = null,
    @SerialName("description") val description: String? = null,
    @SerialName("details") val details: List<MealDetailsDto>? = null,
    @SerialName("nutrition") val nutrition: MealNutritionDto? = null,
)

@Serializable
internal data class MealDetailsDto(
    @SerialName("title") val title: String? = null,
    @SerialName("text") val text: String? = null,
)

@Serializable
internal data class MealNutritionDto(
    @SerialName("product") val product: String? = null,
    @SerialName("portion") val portion: Float? = null,
    @SerialName("calories") val calories: Float? = null,
    @SerialName("fat") val fat: Float? = null,
    @SerialName("carbohydrates") val carbs: Float? = null,
    @SerialName("fiber") val fiber: Float? = null,
    @SerialName("protein") val protein: Float? = null,
)
